"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingService = void 0;
var react_1 = __importDefault(require("react"));
var CensusCollector_1 = require("./CensusCollector");
var OnboardingTypes_1 = require("./OnboardingTypes");
var axios_1 = __importDefault(require("axios"));
var AxiosErrorParser_1 = require("Errors/AxiosErrorParser");
var OnboardingTelemetryService_1 = require("./OnboardingTelemetryService");
var Telemetry_1 = require("Telemetry");
var lodash_1 = require("lodash");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var Utils_1 = require("Utils/Utils");
var BrandFetchDetails_1 = require("@CommonFrontendBackend/Account/Brand/BrandFetchDetails");
var IsPersonalEmail_1 = require("@CommonFrontendBackend/Utils/IsPersonalEmail");
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var DIProvider_1 = __importDefault(require("DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var SpheresBackgroundManager_1 = require("Onboarding/CensusCollector/SpheresBackground/SpheresBackgroundManager");
var Types_1 = require("@CommonFrontend/Project/Types");
var OnboardingService = (function () {
    function OnboardingService(mountReactComponent, overlayStack, apiBaseUrl, user, account, useHistoryDataStore, userListLength, $rootScope, usingFeature, savedBlockService, projectService, isMobile, onboardingTelemetryService, userDataStore, $state) {
        var _this = this;
        this.mountReactComponent = mountReactComponent;
        this.overlayStack = overlayStack;
        this.apiBaseUrl = apiBaseUrl;
        this.user = user;
        this.account = account;
        this.useHistoryDataStore = useHistoryDataStore;
        this.userListLength = userListLength;
        this.$rootScope = $rootScope;
        this.usingFeature = usingFeature;
        this.savedBlockService = savedBlockService;
        this.projectService = projectService;
        this.isMobile = isMobile;
        this.onboardingTelemetryService = onboardingTelemetryService;
        this.userDataStore = userDataStore;
        this.$state = $state;
        this.showCensusCollector = function (config) {
            if (config === void 0) { config = {}; }
            _this.registerOnboardingSequences();
            return new Promise(function (_resolve, _reject) {
                var resolve = function (reason) { return __awaiter(_this, void 0, void 0, function () {
                    var completionData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _resolve(reason == CensusCollector_1.CompletedReason.Finished || reason == CensusCollector_1.CompletedReason.Skipped);
                                return [4, this.savedBlockService.createDefaults()];
                            case 1:
                                _a.sent();
                                completionData = this.onboardingCensusCollectorStore.completionData;
                                if (!this.isMobile()) return [3, 2];
                                this.onboardingTelemetryService.trackProductLanding(OnboardingTelemetryService_1.ProductLandingLocation.Dashboard);
                                return [3, 10];
                            case 2:
                                if (!this.onboardingCensusCollectorMetadataStore.isTemplateSignup) return [3, 3];
                                this.onboardingTelemetryService.trackProductLanding(OnboardingTelemetryService_1.ProductLandingLocation.Editor);
                                this.projectService.open({ _id: this.user.projects }, Telemetry_1.ProjectOpenedOrigin.SignupWithTemplate);
                                return [3, 10];
                            case 3:
                                if (!this.onboardingCensusCollectorMetadataStore.isPageBuilderAISignup) return [3, 4];
                                this.onboardingTelemetryService.trackProductLanding(OnboardingTelemetryService_1.ProductLandingLocation.Editor);
                                this.projectService.open({ _id: this.user.projects }, Telemetry_1.ProjectOpenedOrigin.SignupWithPageBuilderAI);
                                return [3, 10];
                            case 4:
                                if (!config.integrationOnboardingName) return [3, 5];
                                this.onboardingTelemetryService.trackProductLanding(OnboardingTelemetryService_1.ProductLandingLocation.Integrations);
                                this.$state.go("settingsWithSubsection", {
                                    section: "integrations",
                                    subsection: config.integrationOnboardingName,
                                });
                                return [3, 10];
                            case 5:
                                if (!(completionData.landingPoint === CensusCollector_1.ChosenLandingPoint.Editor)) return [3, 9];
                                this.onboardingTelemetryService.trackProductLanding(OnboardingTelemetryService_1.ProductLandingLocation.Editor);
                                if (!completionData.pageId) return [3, 6];
                                this.projectService.open({ _id: completionData.pageId }, Telemetry_1.ProjectOpenedOrigin.OnboardingProject, Types_1.ProjectTourType.OnboardingPage);
                                return [3, 8];
                            case 6: return [4, this.projectService.createWelcomePage()];
                            case 7:
                                _a.sent();
                                _a.label = 8;
                            case 8: return [3, 10];
                            case 9:
                                if (completionData.landingPoint === CensusCollector_1.ChosenLandingPoint.TemplateGallery) {
                                    this.onboardingTelemetryService.trackProductLanding(OnboardingTelemetryService_1.ProductLandingLocation.TemplateGallery);
                                    this.$state.go("templatesGallery", { onboarding: true, tab: completionData.tab });
                                }
                                else {
                                    this.onboardingTelemetryService.trackProductLanding(OnboardingTelemetryService_1.ProductLandingLocation.Dashboard);
                                }
                                _a.label = 10;
                            case 10:
                                this.useHistoryDataStore.completeOnboardingSequence(OnboardingTypes_1.SequenceName.CensusCollector);
                                this.overlayStack.closeCurrent();
                                try {
                                    this.$rootScope.$apply();
                                }
                                catch (error) { }
                                return [2];
                        }
                    });
                }); };
                var reject = function (reason) {
                    _reject(reason);
                    _this.overlayStack.closeCurrent();
                };
                var ui = _this.mountReactComponent(react_1.default.createElement(DIProvider_1.default, { container: function () {
                        var container = new inversify_1.Container({ skipBaseClassChecks: true });
                        container.bind("apiService").toConstantValue(_this.apiService);
                        container.bind("censusCollectorStore").toConstantValue(_this.onboardingCensusCollectorStore);
                        container.bind("censusCollectorMetadataStore").toConstantValue(_this.onboardingCensusCollectorMetadataStore);
                        container.bind("userListLength").toConstantValue(_this.userListLength);
                        container.bind("spheresBackgroundManager").toConstantValue(_this.spheresBackgroundManager);
                        return container;
                    } },
                    react_1.default.createElement(CensusCollector_1.CensusCollector, { resolve: resolve, reject: reject, config: config })));
                _this.overlayStack.add({
                    contentUi: ui,
                    options: {
                        hideCloseButton: true,
                        fullPage: true,
                    },
                });
            });
        };
        this.setUsername = function (firstName, lastName) { return __awaiter(_this, void 0, Promise, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/users/update"), {
                                firstName: firstName,
                                lastName: lastName,
                            }, { withCredentials: true })];
                    case 1:
                        _a.sent();
                        this.user.firstName = firstName;
                        if (lastName) {
                            this.user.lastName = lastName;
                        }
                        this.onboardingTelemetryService.userDataSubmitted({ firstName: firstName, lastName: lastName });
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        throw new Error((0, AxiosErrorParser_1.getErrorMessage)(error_1));
                    case 3: return [2];
                }
            });
        }); };
        this.createTailoredPages = function (templateTypes) { return __awaiter(_this, void 0, Promise, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/onboarding/tailored-pages"), { templateTypes: templateTypes }, {
                                withCredentials: true,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2, response.data];
                    case 2:
                        error_2 = _a.sent();
                        throw new Error((0, AxiosErrorParser_1.getErrorMessage)(error_2));
                    case 3: return [2];
                }
            });
        }); };
        this.fetchBrandDetails = function (domain) { return __awaiter(_this, void 0, Promise, function () {
            var domainToFetch, type, response, fetchData, _a, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        domainToFetch = domain !== null && domain !== void 0 ? domain : ((0, IsPersonalEmail_1.getEmailDomain)(this.user.email) || "");
                        type = !!domain ? BrandFetchDetails_1.BrandFetchType.Manual : BrandFetchDetails_1.BrandFetchType.Auto;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4, axios_1.default.get("".concat(this.apiBaseUrl, "/accounts/").concat(this.account._id, "/brand-fetch/").concat(domainToFetch, "?type=").concat(type), {
                                withCredentials: true,
                            })];
                    case 2:
                        response = _b.sent();
                        fetchData = response.data;
                        _a = fetchData;
                        return [4, Promise.all(fetchData.logos.map(URL_1.toDataURL))];
                    case 3:
                        _a.logos = _b.sent();
                        return [2, fetchData];
                    case 4:
                        error_3 = _b.sent();
                        throw new Error((0, AxiosErrorParser_1.getErrorMessage)(error_3));
                    case 5: return [2];
                }
            });
        }); };
        this.checkSubdomainAvailability = function (subdomain) { return __awaiter(_this, void 0, Promise, function () {
            var response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/accounts/").concat(this.account._id, "/settings/subdomain/usable"), { subdomain: subdomain }, {
                                withCredentials: true,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2, response.data];
                    case 2:
                        error_4 = _a.sent();
                        throw new Error((0, AxiosErrorParser_1.getErrorMessage)(error_4));
                    case 3: return [2];
                }
            });
        }); };
        this.uploadLogos = function (dataUrls) { return __awaiter(_this, void 0, Promise, function () {
            var files, formData, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        files = dataUrls
                            .map(function (url, index) { return (0, URL_1.imageDataURLtoFile)(url, "".concat(BrandFetchDetails_1.LOGO_NAME_PREFIX).concat(index + 1)); })
                            .filter(function (f) { return !!f; });
                        if (files.length === 0) {
                            return [2];
                        }
                        formData = new FormData();
                        files.forEach(function (f) {
                            formData.append("file", f, f.name);
                        });
                        formData.append("clearExistingLogos", "true");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/upload/images"), formData, {
                                withCredentials: true,
                            })];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_5 = _a.sent();
                        throw new Error((0, AxiosErrorParser_1.getErrorMessage)(error_5));
                    case 4: return [2];
                }
            });
        }); };
        this.setPassword = function (password) { return __awaiter(_this, void 0, Promise, function () {
            var error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/users/set-password"), {
                                password: password,
                            }, { withCredentials: true })];
                    case 1:
                        _a.sent();
                        this.user.hasSetPassword = true;
                        return [3, 3];
                    case 2:
                        error_6 = _a.sent();
                        throw new Error(this.errorMessageExtractor(error_6));
                    case 3: return [2];
                }
            });
        }); };
        this.setAccountDetails = function (details) { return __awaiter(_this, void 0, Promise, function () {
            var payload, accountTelemetryData, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        payload = {};
                        if (details.name) {
                            payload.name = details.name;
                        }
                        if (details.crmTechnologyOther) {
                            payload.crmTechnologyOther = details.crmTechnologyOther;
                        }
                        if (!Object.keys(payload).length) return [3, 2];
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/accounts/").concat(this.account._id), payload, { withCredentials: true })];
                    case 1:
                        _a.sent();
                        Object.assign(this.account, payload);
                        if (payload.name) {
                            this.onboardingCensusCollectorStore.updateSuggestedSubdomain(payload.name);
                        }
                        accountTelemetryData = __assign(__assign({}, payload), { companySize: details.companySize, salesTeamSize: details.salesTeamSize, crmTechnology: details.crmTechnology, howDidYouHearAboutUs: details.howDidYouHearAboutUs });
                        this.onboardingTelemetryService.accountDataSubmitted(accountTelemetryData);
                        _a.label = 2;
                    case 2: return [3, 4];
                    case 3:
                        error_7 = _a.sent();
                        throw new Error(this.errorMessageExtractor(error_7));
                    case 4: return [2];
                }
            });
        }); };
        this.updateAccountCensus = function (census) { return __awaiter(_this, void 0, Promise, function () {
            var payload, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        payload = (0, lodash_1.pick)(census, ["crmTechnology"]);
                        if (!!(0, lodash_1.isEmpty)(payload)) return [3, 2];
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/accounts/").concat(this.account._id, "/census"), payload, { withCredentials: true })];
                    case 1:
                        _a.sent();
                        Object.assign(this.account.census, payload);
                        _a.label = 2;
                    case 2: return [3, 4];
                    case 3:
                        error_8 = _a.sent();
                        throw new Error(this.errorMessageExtractor(error_8));
                    case 4: return [2];
                }
            });
        }); };
        this.updateUserCensus = function (census) { return __awaiter(_this, void 0, Promise, function () {
            var payload, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        payload = (0, lodash_1.pick)(census, ["howDidYouHearAboutUs"]);
                        if (!!(0, lodash_1.isEmpty)(payload)) return [3, 2];
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/users/").concat(this.user._id, "/census"), payload, { withCredentials: true })];
                    case 1:
                        _a.sent();
                        Object.assign(this.user.census, census);
                        _a.label = 2;
                    case 2: return [3, 4];
                    case 3:
                        error_9 = _a.sent();
                        throw new Error(this.errorMessageExtractor(error_9));
                    case 4: return [2];
                }
            });
        }); };
        this.sendUserInvites = function (emails) { return __awaiter(_this, void 0, Promise, function () {
            var error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (emails.length === 0) {
                            return [2];
                        }
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/accounts/").concat(this.account._id, "/invites/invite-with-seats"), {
                                invites: emails.map(function (email) { return ({ email: email, role: "admin" }); }),
                            }, { withCredentials: true })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_10 = _a.sent();
                        throw new Error(this.errorMessageExtractor(error_10));
                    case 3:
                        this.onboardingTelemetryService
                            .sendUserInvitedTelemetry({
                            eventOrigin: event_tracker_types_1.EventOrigin.QwilrOnboarding,
                            eventProperties: {
                                planPendingInvites: 0,
                                userInviteeType: "admin",
                            },
                        })
                            .catch(function () { return ({}); });
                        return [2];
                }
            });
        }); };
        this.errorMessageExtractor = function (error) {
            if (error && typeof error === "object") {
                if ((0, Utils_1.hasOwnProperty)(error, "response") &&
                    error.response &&
                    typeof error.response === "object" &&
                    (0, Utils_1.hasOwnProperty)(error.response, "data") &&
                    error.response.data &&
                    typeof error.response.data === "object" &&
                    (0, Utils_1.hasOwnProperty)(error.response.data, "error") &&
                    error.response.data.error &&
                    typeof error.response.data.error === "object" &&
                    (0, Utils_1.hasOwnProperty)(error.response.data.error, "message") &&
                    typeof error.response.data.error.message === "string") {
                    return error.response.data.error.message;
                }
                if ((0, Utils_1.hasOwnProperty)(error, "message") && typeof error.message === "string") {
                    return error.message;
                }
            }
            return "Unknown Error";
        };
        this.onboardingCensusCollectorStore = new CensusCollector_1.CensusCollectorStore(user, account, userListLength);
        this.onboardingCensusCollectorMetadataStore = new CensusCollector_1.CensusCollectorMetadataStore(this.userDataStore, this.useHistoryDataStore);
        this.spheresBackgroundManager = new SpheresBackgroundManager_1.SpheresBackgroundManager();
    }
    OnboardingService.prototype.registerOnboardingSequences = function () {
        if (this.userListLength === 1) {
            this.useHistoryDataStore.registerOnboardingSequence(OnboardingTypes_1.SequenceName.TrialConfirmationModal);
        }
        if (this.usingFeature(FeatureFlag_1.default.TailoredPages)) {
            this.useHistoryDataStore.registerOnboardingSequence(OnboardingTypes_1.SequenceName.TailoredPageTour);
        }
    };
    Object.defineProperty(OnboardingService.prototype, "apiService", {
        get: function () {
            return {
                setUsername: this.setUsername,
                setPassword: this.setPassword,
                setAccountDetails: this.setAccountDetails,
                sendUserInvites: this.sendUserInvites,
                updateAccountCensus: this.updateAccountCensus,
                updateUserCensus: this.updateUserCensus,
                createTailoredPages: this.createTailoredPages,
                fetchBrandDetails: this.fetchBrandDetails,
                checkSubdomainAvailability: this.checkSubdomainAvailability,
                uploadLogos: this.uploadLogos,
            };
        },
        enumerable: false,
        configurable: true
    });
    return OnboardingService;
}());
exports.OnboardingService = OnboardingService;
